<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
  >
    <div class="bg-eerie-black p-6 rounded-lg shadow-lg text-center max-w-sm w-full">
      <h2 class="text-xl text-total-white font-bold mb-4">{{ heading ?? "Delete Project" }}</h2>
      <p class="text-sm text-total-white-500 mb-6">
        {{ message ?? "Are you sure you want to delete this project? This operation might be irreversible." }}
      </p>
      <div class="flex justify-around">
        <button
          @click="confirmDelete"
          class="bg-deep-rust text-white px-4 py-2 rounded-lg"
        >
          Delete
        </button>
        <button @click="cancelDelete" class="bg-gray-700 text-white px-4 py-2 rounded-lg">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    heading: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  methods: {
    confirmDelete() {
      // Trigger delete logic
      this.$emit("confirmDelete");
    },
    cancelDelete() {
      // Close modal without deleting
      this.$emit("cancelDelete");
    },
  },
};
</script>

<style scoped>
/* Delete Modal specific styling */
</style>
